import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import './styles/index.css';
import './i18n';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || "388113463782-mv5laegn2gme80jscl0g0g6oitjt9k7r.apps.googleusercontent.com"}>
      <React.Suspense fallback={<div style={{height: '100vh', backgroundColor: '#050505'}}></div>}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </React.Suspense>
    </GoogleOAuthProvider>
  </React.StrictMode>
);

